import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=ba00284c"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports